export default __webpack_public_path__ + "static/media/signin.b0d6f860.svg";